import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import React from "react";
import { WorkflowStateI } from "../views/WorkFlow";

interface MultipliedFieldCompI {
  name: string;
  sourceOne: string;
  sourceTwo: string;
  workflow: WorkflowStateI;
  positions: string[];
  onButtonClick: (value: string) => void;
}
export const MultipliedFieldComp = (props: MultipliedFieldCompI) => {
  return (
    <Card sx={{ maxWidth: 275, minWidth: 275 }}>
      <CardContent>
        <Typography sx={{ fontSize: 14 }} gutterBottom>
          MULTIPLIEDFIELD
        </Typography>
        <Typography variant="h6" component="div">
          <div>Name: {props.name} </div>
          <div>Source 1: {props.sourceOne} </div>
          <div>Source 2: {props.sourceTwo} </div>
        </Typography>
        <div>
          Positionen:
          {props.positions &&
            props.positions.map((item, index) => {
              return <span key={index}> {item} </span>;
            })}
        </div>
      </CardContent>
      <CardActions>
        <Button
          size="small"
          onClick={() => {
            props.onButtonClick(props.name);
          }}
          variant="contained"
        >
          Position hinzufügen
        </Button>
      </CardActions>
    </Card>
  );
};
